import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    CryptoWalletNetworkType,
    GiftCardProviderType,
    WithdrawalRequestPaymentMethodType,
    WithdrawalRequestStatusType,
} from '../models/withdrawals.interface';
import { WithdrawalRequestsWithPagination } from '../models/api/response/user-management.response';
import { endpoints } from '@shared/endpoints';
import { WithdrawalRequest } from '../models/api/requests/user-management.request';

@Injectable({
    providedIn: 'root',
})
export class WithdrawalsService {
    constructor(private http: HttpClient) {}

    fetchWithdrawalRequests(
        status?: WithdrawalRequestStatusType,
        paymentMethod?: WithdrawalRequestPaymentMethodType,
        network?: CryptoWalletNetworkType,
        giftCardProvider?: GiftCardProviderType
    ) {
        let params = new HttpParams();
        let filters = '';
        if (status) {
            filters = `${filters}status==${status}`;
        }
        if (paymentMethod) {
            filters = `${filters},paymentMethod==${paymentMethod}`;
        }
        if (network) {
            filters = `${filters},cryptoWalletNetwork==${network}`;
        }
        if (giftCardProvider) {
            filters = `${filters},giftCardProviderType==${giftCardProvider}`;
        }

        if (filters) {
            params = params.append('Filters', filters);

            params = params.append('PageSize', '99999999');
        }

        return this.http.get<WithdrawalRequestsWithPagination>(
            endpoints.withdrawals.children.getWithdrawalRequestsUrl(),
            { params }
        );
    }
    changeWithdrawalRequestStatus(
        profileId: string,
        requestId: string,
        status: WithdrawalRequestStatusType
    ) {
        return this.http.post<WithdrawalRequest>(
            endpoints.admin.children.changeWithdrawalRequest(
                profileId,
                requestId,
                status
            ),
            {}
        );
    }

    addHashIdToWithdrawallRequest(hashId: string, withdrawalId: string) {
        return this.http.patch(
            endpoints.withdrawals.children.addHashToWithdrawalRequest(
                withdrawalId
            ),
            { cryptoHashId: hashId }
        );
    }
}
